import { Inject, Injectable, Optional } from '@angular/core';
import {
    MAT_MOMENT_DATE_ADAPTER_OPTIONS,
    MatMomentDateAdapterOptions,
    MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { Moment } from 'moment';
import moment from 'moment-timezone';

@Injectable()
export class TimezoneDateAdapter extends MomentDateAdapter {

    private _timezoneId: string = moment.tz.guess();

    get timezoneId(): string {
        return this._timezoneId;
    }

    constructor(
        @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string,
        @Optional() @Inject(MAT_MOMENT_DATE_ADAPTER_OPTIONS) _options?: MatMomentDateAdapterOptions,
    ) {
        super(dateLocale, _options);
    }

    setTimezoneId(timezoneId: string): void {
        if (!moment.tz.names().includes(timezoneId)) {
            throw new Error(`IANA Timezone ID "${timezoneId}" not recognized`);
        }
        this._timezoneId = timezoneId;
    }

    override format(date: Moment, displayFormat: string): string {
        const timeZoneDate = moment(date).tz(this._timezoneId).locale(this._timezoneId);
        return timeZoneDate.format(displayFormat);
    }

    override createDate(year: number, month: number, day: number): moment.Moment {
        let result = super.createDate(year, month, day);
        result = this._timezoneId
            ? result.tz(this._timezoneId, true)
            : result;
        return result;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    override parse(value: any, parseFormat: moment.MomentFormatSpecification): moment.Moment | null {
        if (!value) {
            return null;
        }

        let format = null;
        if (typeof value == 'string') {
            format = parseFormat;
        }

        return moment.tz(value, format, this.locale, true, this._timezoneId).locale(this.locale);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    override deserialize(value: any): Moment {
        return super.deserialize(value)?.tz(this._timezoneId);
    }

    override today(): Moment {
        return super.today().tz(this._timezoneId);
    }

    override compareDate(first: Moment, second: Moment): number {
        return first.valueOf() - second.valueOf();
    }

    override getFirstDayOfWeek(): number {
        return 0;
    }
}
